import { hasOwnKey } from "@cayo/shared/utils/typeUtils";
import { allRendereres } from "./index";

export type RendererHandler = (...args: any[]) => JSX.Element;

export function getSchemeRenderer(name: unknown): RendererHandler | null {
  // This function checks if the provided name is a valid renderer name
  // and returns the corresponding renderer handler if it exists.
  if (typeof name !== "string") {
    return null;
  }

  return hasOwnKey(allRendereres, name) ? (allRendereres[name] as RendererHandler) : null;
}
